export type PasswordScore = 0 | 1 | 2 | 3 | 4;

const LABELS = ["", "Weak", "Fair", "Good", "Strong"] as const;
const COLORS = ["#DDE2EB", "#C81E3C", "#B45309", "#15803D", "#15803D"] as const;

const LOWER = /[a-z]/;
const UPPER = /[A-Z]/;
const NUMBER = /\d/;
const SYMBOL = /[^A-Za-z0-9]/;

const characterClasses = (password: string): number =>
  Number(LOWER.test(password)) +
  Number(UPPER.test(password)) +
  Number(NUMBER.test(password)) +
  Number(SYMBOL.test(password));

export const passwordScore = (password: string): PasswordScore => {
  if (!password) {
    return 0;
  }
  if (password.length < 8) {
    return 1;
  }
  const classes = characterClasses(password);
  const score =
    1 +
    Number(password.length >= 12) +
    Number(classes >= 3) +
    Number(classes === 4 || password.length >= 16);
  return Math.min(4, score) as PasswordScore;
};

export const strengthLabel = (score: PasswordScore): string => LABELS[score];

export const strengthColor = (score: PasswordScore): string => COLORS[score];

export const strengthHint = (
  password: string,
  score: PasswordScore,
  failedShort: boolean
): string => {
  if (failedShort) {
    return "Use at least 8 characters.";
  }
  if (password.length < 8) {
    return "At least 8 characters.";
  }
  if (score === 4) {
    return "Great password.";
  }
  if (score === 2 || score === 3) {
    return "Longer passphrases are strongest.";
  }
  return "";
};
